module.exports = __webpack_public_path__ + "img/p94.a9466de2.png";